<template>
    <div>
        <vs-card class="content_mb_0 mb-0">
            <vs-row>
                <vs-col vs-lg="7" vs-sm="12" class="p-2">
                    <vs-input class="lg:w-3/4 w-full" placeholder="Search" />
                </vs-col>
                <vs-col vs-lg="5" vs-sm="12" class="p-2">
                    <div class="flex flex-wrap justify-end items-center">
                        <label class="vs--input-label">Attendance</label>
                        <v-select class="mx-1" style="width: 200px;"></v-select>
                    </div>
                </vs-col>
            </vs-row>
        </vs-card>
    </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  }
}
</script>